<script setup lang="ts">
  import {useI18n} from 'vue-i18n';
  import useCpBem from '~/composables/useCpBem';
  import CpText from '~/components/cp/CpText/CpText.vue';

  const {b, e} = useCpBem('cp-card-faq');

  withDefaults(defineProps<{
    title: string,
    image: string
  }>(), {});

  defineEmits({
    click: null,
  });

</script>

<template>
    <div :class="b">
        <div :class="e`content`">
            <img :src="image" :alt="title" :class="e('image')">
            <div :class="e`vertical-container`">
                <CpText :class="e('title')" variant="body-bold" type="primary">
                    {{ title }}
                </CpText>
                <CpText variant="body-regular">
                    <slot />
                </CpText>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
  @import "assets/style/global.scss";

  .cp-card-faq {
    display: flex;
    flex-direction: column;
    border-radius: $cp-border-radius;
    border: $cp-border-standard;

    &__content {
      padding: $cp-gutter;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: $cp-gutter;
    }

    &__title {
      padding-bottom: $cp-gutter-small;
    }

    &__vertical-container {
       display: flex;
       flex-direction: column;
       flex: 1;
    }

    &__image {
      width: 80px;
      border-radius: $cp-border-radius;
    }
  }
</style>
